import {
  UPDATE_THEME
} from '../../constants'
import { PayloadAction } from '@reduxjs/toolkit'
import  { Theme } from '../../type/userSettings'

export const updateTheme = (theme: Theme): PayloadAction<any> => {
  return {
    type: UPDATE_THEME,
    payload: {
      theme
    }
  }
}
